import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { teamsData } from './teamData';

// Player stats data
const playerStats = {
  setters: [
    { name: "Sameer Chaudhary", team: "Mathura Yodhas", matches: 8, sets: 210 },
    { name: "Saqlain Tariq", team: "Gorakhpur Giants", matches: 7, sets: 198 },
    { name: "Surya Nanjil", team: "Muzzafarnagar Lions", matches: 7, sets: 191 },
    { name: "Vipul Kumar", team: "Noida Thunders", matches: 7, sets: 150 },
    { name: "Muthuswamy Appavu", team: "Ayodhya Super Kings", matches: 5, sets: 103 }
  ],
  liberos: [
    { name: "Hari Prasad", team: "Mathura Yodhas", matches: 8, receives: 52 },
    { name: "Arjun Singh", team: "Gorakhpur Giants", matches: 7, receives: 46 },
    { name: "Guru C", team: "Noida Thunders", matches: 6, receives: 41 },
    { name: "Prem Singh", team: "Ayodhya Super Kings", matches: 5, receives: 30 },
    { name: "Soyab Chaudhary", team: "Lucknow Tigers", matches: 5, receives: 29 }
  ],
  mvps: [
    { name: "Jerome Vinith", team: "Muzzafarnagar Lions", matches: 7, spikes: 95, blocks: 4, serves: 15, total: 114, superServe: 2 },
    { name: "Chirag Yadav", team: "Muzzafarnagar Lions", matches: 7, spikes: 89, blocks: 8, serves: 15, total: 112, superServe: 4 },
    { name: "Vinit Kumar", team: "Mathura Yodhas", matches: 8, spikes: 73, blocks: 14, serves: 6, total: 93, superServe: 2 },
    { name: "Rohit Kumar", team: "Mathura Yodhas", matches: 8, spikes: 68, blocks: 11, serves: 9, total: 88, superServe: 2 },
    { name: "Mohd Saeed Alam", team: "Mathura Yodhas", matches: 8, spikes: 62, blocks: 9, serves: 4, total: 75, superServe: 0 }
  ],
  blockers: [
    { name: "Shikhar Singh", team: "Gorakhpur Giants", matches: 7, blocks: 21 },
    { name: "Prince", team: "Mathura Yodhas", matches: 8, blocks: 21 },
    { name: "Naveen Baliyan", team: "Muzzafarnagar Lions", matches: 7, blocks: 20 },
    { name: "Abhilash Chaudhary", team: "Mathura Yodhas", matches: 7, blocks: 15 },
    { name: "Vinit Kumar", team: "Mathura Yodhas", matches: 8, blocks: 14 }
  ],
  oppositeHitters: [
    { name: "Jerome Vinith", team: "Muzzafarnagar Lions", matches: 7, spikes: 95, blocks: 4, serves: 15, total: 114 },
    { name: "Vinit Kumar", team: "Mathura Yodhas", matches: 8, spikes: 73, blocks: 14, serves: 6, total: 93 },
    { name: "Shubham Chaudhury", team: "Noida Thunders", matches: 6, spikes: 67, blocks: 4, serves: 2, total: 73 },
    { name: "Vikram", team: "Gorakhpur Giants", matches: 4, spikes: 50, blocks: 0, serves: 7, total: 57 },
    { name: "Angamuthu Ramaswamy", team: "Moradabad Bulls", matches: 5, spikes: 38, blocks: 4, serves: 2, total: 44 }
  ],
  outsideHitters: [
    { name: "Chirag Yadav", team: "Muzzafarnagar Lions", matches: 7, spikes: 89 },
    { name: "Rohit Kumar", team: "Mathura Yodhas", matches: 8, spikes: 68 },
    { name: "Mohd Saeed Alam", team: "Mathura Yodhas", matches: 8, spikes: 62 },
    { name: "Ashok", team: "Gorakhpur Giants", matches: 7, spikes: 60 },
    { name: "Nandhagopal Subramaniam", team: "Noida Thunders", matches: 6, spikes: 51 }
  ],
  emergingPlayers: [
    { name: "Mohd Saeed Alam", team: "Mathura Yodhas", age: 20, matches: 8, spikes: 62, blocks: 9, serves: 4, total: 75 },
    { name: "Abdul Chisti", team: "Gorakhpur Giants", age: 20, matches: 5, spikes: 32, blocks: 2, serves: 3, total: 37 },
    { name: "Tanish Chaudhary", team: "Ayodhya Super Kings", age: 20, matches: 5, spikes: 26, blocks: 3, serves: 4, total: 33 },
    { name: "Rajat Singh", team: "Moradabad Bulls", age: 17, matches: 5, spikes: 26, blocks: 3, serves: 4, total: 33 },
    { name: "Aryan Baliyan", team: "Kashi Warriors", age: 18, matches: 4, spikes: 26, blocks: 3, serves: 3, total: 32 }
  ]
};

// Team logo mapping
const teamLogos = {
  "Mathura Yodhas": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324937/mathura_mrfm5a.png",
  "Gorakhpur Giants": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324937/gorakhpur_cwawjd.png",
  "Muzzafarnagar Lions": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324934/muzaffarnagar_e70oto.png",
  "Noida Thunders": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324937/noida_k5ryqe.png",
  "Ayodhya Super Kings": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324935/ayodhya_jr2yhp.png",
  "Lucknow Tigers": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324936/lucknow_h9jbki.png",
  "Moradabad Bulls": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324937/moradabad_vfvxlf.png",
  "Kashi Warriors": "https://res.cloudinary.com/dctkzy9nd/image/upload/v1754324937/kashi_f2ue3v.png"
};

export default function Team() {
  const [showTeams, setShowTeams] = useState(true);

  // Component for standard player cards (Top Setter, Top Libero, etc.)
  const StandardPlayerCard = ({ title, players, statKey, statLabel }) => {
    return (
      <div className="stats-card">
        <div className="stats-card-header">
          <h3>{title}</h3>
        </div>
        
        {/* 1st Position Player */}
        <div className="first-player">
          <div className="player-name-large">{players[0].name}</div>
          
          <div className="player-details-container">
            <div className="player-stats-row">
              <div className="player-stats-col">
                <div className="stat-value">{players[0][statKey]}</div>
                <div className="stat-label">{statLabel}</div>
              </div>
              <div className="vertical-divider"></div>
              <div className="player-logo-col">
                <img src={teamLogos[players[0].team]} alt={players[0].team} className="team-logo" />
              </div>
            </div>
            
            <div className="matches-row">
              <div className="matches-label">Matches: {players[0].matches}</div>
            </div>
          </div>
        </div>
        
        {/* Players 2-5 */}
        {players.slice(1, 5).map((player, index) => (
          <div key={index} className="standard-player-row">
            <div className="player-info-row">
              <div className="player-info-col">
                <div className="player-name-small">{player.name}</div>
                <div className="player-team">{player.team}</div>
              </div>
              <div className="player-stat-col">
                <div className="stat-label-small">Sets</div>
                <div className="stat-value-small">{player[statKey]}</div>
              </div>
            </div>
            
            <div className="player-matches-row">
              <div className="matches-label-small">Matches: {player.matches}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Component for MVP-style player cards
  const MVPPlayerCard = ({ title, players }) => {
    return (
      <div className="stats-card">
        <div className="stats-card-header">
          <h3>{title}</h3>
        </div>
        
        {/* 1st Position Player */}
        <div className="first-player">
          <div className="player-name-large">{players[0].name}</div>
          
          <div className="player-details-container">
            <div className="player-stats-row">
              <div className="player-stats-col">
                <div className="stat-value">{players[0].total}</div>
                <div className="stat-label">Total Points</div>
              </div>
              <div className="vertical-divider"></div>
              <div className="player-logo-col">
                <img src={teamLogos[players[0].team]} alt={players[0].team} className="team-logo" />
              </div>
            </div>
            
            <div className="matches-row">
              <div className="matches-label">Matches: {players[0].matches}</div>
            </div>
          </div>
        </div>
        
        {/* Players 2-5 */}
        {players.slice(1, 5).map((player, index) => (
          <div key={index} className="mvp-player-row">
            <div className="player-info-row">
              <div className="player-info-col">
                <div className="player-name-small">{player.name}</div>
                <div className="player-team">{player.team}</div>
              </div>
              <div className="player-stat-col">
                <div className="stat-label-small">Total</div>
                <div className="stat-value-small">{player.total}</div>
              </div>
            </div>
            
            <div className="player-stats-grid">
              <div className="stat-item">
                <div className="stat-value-tiny">{player.matches}</div>
                <div className="stat-label-tiny">Matches</div>
              </div>
              <div className="stat-item">
                <div className="stat-value-tiny">{player.spikes}</div>
                <div className="stat-label-tiny">Spikes</div>
              </div>
              <div className="stat-item">
                <div className="stat-value-tiny">{player.blocks}</div>
                <div className="stat-label-tiny">Blocks</div>
              </div>
              <div className="stat-item">
                <div className="stat-value-tiny">{player.serves}</div>
                <div className="stat-label-tiny">Serves</div>
              </div>
              <div className="stat-item">
                <div className="stat-value-tiny">{player.superServe || 0}</div>
                <div className="stat-label-tiny">Super Serves</div>
              </div>
            </div>
            
            {/* <div className="player-stats-grid">
            </div> */}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="breadcrumb-container">
        <div className="breadcrumb-overlay">
          <div className="breadcrumb-content">
            <h1 className="breadcrumb-title">Team & Stats</h1>
          </div>
        </div>
      </div>
      
      <section id="teameet">
        <div className="container-fluid">
          {/* Toggle Button */}
          <div className="view-toggle">
            <button 
              className={`toggle-btn ${showTeams ? 'active' : ''}`}
              onClick={() => setShowTeams(true)}
            >
              Teams
            </button>
            <button 
              className={`toggle-btn ${!showTeams ? 'active' : ''}`}
              onClick={() => setShowTeams(false)}
            >
              Players Statistics
            </button>
          </div>

          {showTeams ? (
            <>
              <div className="contact-title" style={{color:"#fff", marginTop: "4rem", marginBottom: "3rem"}}>
                <h4>Explore Teams</h4>
                <p>
                  For any inquiries, partnership opportunities, or further information, 
                  feel free to reach out to us directly through the contact details below.
                </p>
              </div>

              <div className="row">
                {teamsData.map((team) => (
                  <div className="col-md-3 col-6 text-center mb-4" key={team.id}>
                    <Link to={`/team/${team.slug}`} className="team-card">
                      <img 
                        src={team.bannerImage} 
                        className="img-fluid t1" 
                        alt={team.name}
                      />
                      <h6 className="mt-2 text-white" >{team.name}</h6>
                    </Link>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="player-stats-container">
              {/* First row with 4 cards */}
              <div className="stats-row">
                <StandardPlayerCard 
                  title="Top Setter" 
                  players={playerStats.setters} 
                  statKey="sets" 
                  statLabel="Sets" 
                />
                <StandardPlayerCard 
                  title="Top Libero" 
                  players={playerStats.liberos} 
                  statKey="receives" 
                  statLabel="Receives" 
                />
                <StandardPlayerCard 
                  title="Top Blocker" 
                  players={playerStats.blockers} 
                  statKey="blocks" 
                  statLabel="Blocks" 
                />
                <StandardPlayerCard 
                  title="Top Outside Hitter" 
                  players={playerStats.outsideHitters} 
                  statKey="spikes" 
                  statLabel="Spikes" 
                />
              </div>
              
              {/* Second row with 3 cards centered */}
              <div className="stats-row">
                <MVPPlayerCard 
                  title="Most Valuable Player" 
                  players={playerStats.mvps} 
                />
                <MVPPlayerCard 
                  title="Top Opposite Hitter" 
                  players={playerStats.oppositeHitters} 
                />
                <MVPPlayerCard 
                  title="Emerging Players" 
                  players={playerStats.emergingPlayers} 
                />
              </div>
            </div>
          )}
        </div>
      </section>

      <style>{`
        .team-card {
          display: block;
          transition: all 0.3s ease;
          text-decoration: none;
          color: inherit;
        }
        #teameet{
          background: #091331;
        }

        .team-card:hover {
          transform: translateY(-5px);
        }
        .t1 {
          border-radius: 12px;
          transition: transform 0.3s ease;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        .team-card:hover .t1 {
          transform: scale(1.03);
          box-shadow: 0 8px 16px rgba(0,0,0,0.2);
        }
        
        /* Toggle Button Styles */
        .view-toggle {
          display: flex;
          justify-content: center;
          margin: 2rem 0 3rem;
        }
        
        .toggle-btn {
          padding: 5px 25px;
          margin: 0 15px;
          background: transparent;
          border: 2px solid #0D6EFD;
          color: #fff;
          border-radius: 30px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .toggle-btn.active {
          background: #0D6EFD;
          color: #fff;
          box-shadow: 0 0 15px rgba(13, 110, 253, 0.5);
        }
        
        .toggle-btn:hover {
          background: #0b5ed7;
          color: #fff;
        }
        
        /* Player Stats Container */
        .player-stats-container {
          padding: 1rem 2rem;
        }
        
        .stats-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 2rem;
          gap: 20px;
        }
        
        /* Stats Card */
        .stats-card {
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
          width: 280px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        
        .stats-card-header {
          background: #f8f9fa;
          padding: 1rem;
          text-align: center;
          border-bottom: 1px solid #e9ecef;
        }
        
        .stats-card-header h3 {
        background: #091331;
          margin: 0;
          color:rgb(255, 255, 255);
          font-size: 1.2rem;
          font-weight: 600;
          padding: 5px 0;
          border-radius: 12px 12px 12px 12px;


        }
        
        /* First Player Section */
        .first-player {
          padding: 1.2rem;
          border-bottom: 1px solid #e9ecef;
        }
        
        .player-name-large {
          font-size: 1.3rem;
          font-weight: 700;
          color: #212529;
          margin-bottom: 1rem;
          text-align: center;
        }
        
        .player-details-container {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 0.8rem;
        }
        
        .player-stats-row {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.8rem;
        }
        
        .player-stats-col {
          flex: 1;
          text-align: center;
        }
        
        .stat-value {
          font-size: 2rem;
          font-weight: 700;
          color: #0D6EFD;
          line-height: 1;
        }
        
        .stat-label {
          font-size: 0.9rem;
          color: #6c757d;
          margin-top: 0.3rem;
        }
        
        .vertical-divider {
          width: 1px;
          height: 50px;
          background: #dee2e6;
          margin: 0 1rem;
        }
        
        .player-logo-col {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 90px;
        }
        
        .team-logo {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          object-fit: cover;
        }
        
        .matches-row {
          text-align: center;
        }
        
        .matches-label {
          font-size: 0.9rem;
          color: #6c757d;
          font-weight: 500;
        }
        
        /* Standard Player Rows (2nd to 5th) */
        .standard-player-row {
          padding: 0.8rem 1.2rem;
          border-bottom: 1px solid #e9ecef;
        }
        
        .standard-player-row:last-child {
          border-bottom: none;
        }
        
        .player-info-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        
        .player-info-col {
          flex: 1;
        }
        
        .player-name-small {
          font-size: 1rem;
          font-weight: 600;
          color: #212529;
          margin-bottom: 0.2rem;
        }
        
        .player-team {
          font-size: 0.8rem;
          color: #6c757d;
        }
        
        .player-stat-col {
          text-align: right;
          min-width: 60px;
        }
        
        .stat-label-small {
          font-size: 0.7rem;
          color: #6c757d;
          margin-bottom: 0.2rem;
        }
        
        .stat-value-small {
          font-size: 1.1rem;
          font-weight: 700;
          color: #0D6EFD;
        }
        
        .player-matches-row {
          display: flex;
          justify-content: flex-end;
        }
        
        .matches-label-small {
          font-size: 0.8rem;
          color: #6c757d;
        }
        
        /* MVP Player Rows (2nd to 5th) */
        .mvp-player-row {
          padding: 0.8rem 1.2rem;
          border-bottom: 1px solid #e9ecef;
        }
        
        .mvp-player-row:last-child {
          border-bottom: none;
        }
        
        .player-stats-grid {
          display: flex;
          justify-content: space-between;
          margin: 0.5rem 0;
        }
        
        .stat-item {
          text-align: center;
          flex: 1;
        }
        
        .stat-value-tiny {
          font-size: 1rem;
          font-weight: 700;
          color: #0D6EFD;
          margin-bottom: 0.2rem;
        }
        
        .stat-label-tiny {
          font-size: 0.7rem;
          color: #6c757d;
        }
        
        /* Responsive Design */
        @media (max-width: 1200px) {
          .player-stats-container {
            padding: 1rem;
          }
          
          .stats-card {
            width: calc(50% - 20px);
            min-width: 280px;
          }
        }
        
        @media (max-width: 768px) {
          .stats-row {
            justify-content: center;
          }
          
          .stats-card {
            width: 100%;
            max-width: 400px;
          }
        }
        
        @media (max-width: 576px) {
          .view-toggle {
            flex-direction: column;
            align-items: center;
          }
          
          .toggle-btn {
            margin: 0.5rem 0;
            width: 200px;
          }
          
          .player-stats-row {
            flex-direction: column;
            text-align: center;
          }
          
          .vertical-divider {
            width: 80%;
            height: 1px;
            margin: 0.8rem 0;
          }
        }
      `}</style>
    </>
  );
}